module.exports = __webpack_public_path__ + "static/media/32.8cb8a814.JPG";